module.exports = __webpack_public_path__ + "static/media/golf-sucks.d694145a.png";